import { FC, memo } from 'react';
import clsx from 'clsx';
import { Icon } from '@marriott/mi-ui-library';

import { useWalletWidgetTierColor } from '../__utils__';
import { WalletWidgetContainerBadge } from './WalletWidgetContainerBadge';

type WalletWidgetContainerHeaderProps = {
  badgeIcon?: string;
  headerIcon?: string;
  headerLabel: string;
  publishedText?: string;
};

export const WalletWidgetContainerHeader: FC<WalletWidgetContainerHeaderProps> = memo(
  ({ badgeIcon, headerIcon, headerLabel, publishedText }) => {
    const headerIconColor = useWalletWidgetTierColor(headerIcon);

    return (
      <div className="wallet-widget-container__header-wrapper">
        <div className="wallet-widget-container__header-section">
          {headerIcon && (
            <span
              className="wallet-widget-container__header-icon-wrapper"
              aria-hidden="true"
              style={headerIconColor ? { color: headerIconColor } : undefined}
            >
              <Icon iconClass={clsx('wallet-widget-container__header-icon', headerIcon)} isDecorative ariaLabel="" />
            </span>
          )}
          <span className="wallet-widget-container__header-label">{headerLabel}</span>
        </div>

        <WalletWidgetContainerBadge badgeIcon={badgeIcon} publishedText={publishedText} />
      </div>
    );
  }
);

WalletWidgetContainerHeader.displayName = 'WalletWidgetContainerHeader';
